import { Maybe } from '../../../graphql/schema';
import { BookingDropdownOption } from '../../../models/entities/booking.model';
import { DatesAvailabilityType } from '../../../models/entities/calendar.model';
import GenericGetter from '../../../models/store/generic-getter.model';
import ScheduledTestDrivesState from '../../../models/store/modules/scheduled-test-drives-state.model';

import BookingService from '../../../services/booking.service';
import DateService from '../../../services/date.service';

/* ==================== GETTERS ==================== */
const testDriveBookingsCalendar = (
  state: ScheduledTestDrivesState
): Maybe<DatesAvailabilityType> => {
  return state.testDriveBookingsCalendar &&
    state.testDriveBookingsCalendar.length > 0
    ? DateService.getDatesAvailability(state.testDriveBookingsCalendar)
    : {
        availableDates: [],
        closedDates: [],
      };
};

const testDriveBookingsTimeSlots = (
  state: ScheduledTestDrivesState,
  getter: GenericGetter
): Maybe<BookingDropdownOption[]> => {
  return BookingService.getBookingSlots(
    state.testDriveBookingsTimeSlots,
    getter.localeCode,
    true
  );
};

export const getters = {
  testDriveBookingsCalendar,
  testDriveBookingsTimeSlots,
};
